import React from "react";
import { url } from "lib/format";

export default class FallbackImage extends React.Component {
  render() {
    if (this.state && this.state.error) return this.props.children;
    return (
      <div
        className="menu-image"
        {...this.props}
        onError={(e) => this.setState({ error: true })}
        children={null}
        aria-hidden="true"
      />
    );
  }
}
